<template lang="pug">
    #auth
        .container.back-link-container
            transition(name="fade" mode="out-in")
                a.back-link(@click="goBack" v-if="$route.fullPath !== '/'") ← Back
        .section
            .container
                Logo
                transition(name="fade" mode="out-in")
                    router-view(:key="$route.name" name="auth")
</template>

<script>
import Logo from "./Logo";
export default {
  name: "Auth",
  components: {
    Logo
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
#auth {
  max-height: 100%;
  overflow-y: auto;

  .logo {
    width: auto;
    height: 6rem;
    margin: 10vh 0;

    @media screen and (max-width: $tablet) {
      margin: 0 0 10vh;
    }
  }

  .label {
    color: $defaultColor;
  }

  a {
    color: $defaultColor;

    &.attention {
      color: #ffd324 !important;
      text-decoration: underline;
      font-weight: 600;
    }

    &:hover {
      opacity: 0.9;
    }
  }

  .back-link-container {
    padding: 1rem 1.5rem 0;

    &:empty {
      padding: 1rem 1.5rem 1.5rem;
    }

    .back-link {
      padding: 1rem;
      margin: -1rem;
      font-weight: 600;
    }
  }
}
</style>
